import { tx as translateInterfaceText } from '@/utils/i18n';
/**
 * Card Service - Serviço para gerenciamento de cartões de crédito
 *
 * Fornece métodos para criar, listar, definir padrão e deletar cartões
 */

import { authApi } from './authService';

interface CreateCardData {
  token: string;
}

interface SetDefaultCardData {
  cardId: string;
}

export const cardService = {
  /**
   * POST /cards/:id_Stripe_Client
   * Cria um novo cartão para o cliente
   */
  createCard: async (idStripeClient: string, data: CreateCardData) => {
    try {
      const response = await authApi.post(`/cards/${idStripeClient}`, data);
      return response.data;
    } catch (error: any) {
      return error?.response?.data || { success: false, message: translateInterfaceText("Erro ao criar cartão") };
    }
  },

  /**
   * GET /cards/:id_Stripe_Client
   * Lista todos os cartões do cliente
   */
  getAllUserCard: async (idStripeClient: string) => {
    try {
      const response = await authApi.get(`/cards/${idStripeClient}`);
      return response.data;
    } catch (error: any) {
      return error?.response?.data || { success: false, message: translateInterfaceText("Erro ao buscar cartões") };
    }
  },

  /**
   * PATCH /cards/:id_Stripe_Client
   * Define um cartão como padrão
   */
  setDefaultCard: async (idStripeClient: string, data: SetDefaultCardData) => {
    try {
      const response = await authApi.patch(`/cards/${idStripeClient}`, {
        default_source: data.cardId,
      });
      return response.data;
    } catch (error: any) {
      return error?.response?.data || { success: false, message: translateInterfaceText("Erro ao definir cartão padrão") };
    }
  },

  /**
   * GET /customer/search/:id_Stripe_Client
   * Busca informações de endereço do cliente
   */
  getAddressInfo: async (idStripeClient: string) => {
    try {
      const response = await authApi.get(`/customer/search/${idStripeClient}`);
      return response.data;
    } catch (error: any) {
      return error?.response?.data || { success: false, message: translateInterfaceText("Erro ao buscar informações") };
    }
  },

  /**
   * DELETE /cards/:id_Stripe_Client
   * Remove um cartão
   */
  deleteCard: async (idStripeClient: string, cardId: string) => {
    try {
      const response = await authApi.delete(`/cards/${idStripeClient}`, {
        data: { cardId },
      });
      return response.data;
    } catch (error: any) {
      return error?.response?.data || { success: false, message: translateInterfaceText("Erro ao deletar cartão") };
    }
  },
};

export default cardService;
